module.exports = __webpack_public_path__ + "static/media/eel.782545d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/accessory_image/protein/eel.jpg
// module id = 105
// module chunks = 0